import { parse, format } from 'date-fns';
import { concat, get } from 'lodash-es';
import { ltpFeedService } from '../../services/equity/ltpFeedService';

export const formatGlobalIndicesDate = (date = '') => {
	try {
		const parsedDate = parse(date, 'dd-MMM-yyyy HH:mm:ss', new Date());
		const formattedDate = format(parsedDate, 'dd MMM yyyy h:mm a');
		return formattedDate;
	} catch (err) {
		console.log('GetinEr', err);
		return '';
	}
};
export const getIndianIndicesToken = (indianIndices) => {
	const BSE_KEY = get(indianIndices, 'BSE.key', {});
	const NSE_KEY = get(indianIndices, 'NSE.key', {});
	const BSE_SECTOR = get(indianIndices, 'BSE.sector', {});
	const NSE_SECTOR = get(indianIndices, 'NSE.sector', {});
	const DATA = concat(BSE_KEY, NSE_KEY, BSE_SECTOR, NSE_SECTOR);
	const tokenList = [];
	DATA.forEach((indices) => {
		const tokenObject = {
			token: indices?.nToken,
			marketSegment: indices?.nMarketSegmentId,
		};
		tokenList.push(tokenObject);
	});
	return tokenList;
};

export const formatDateOnUser = (date, isGuestUser) => {
	if (isGuestUser) {
		return formatGlobalIndicesDate(date);
	} else {
		const formattedTradedTime = ltpFeedService.formatLastTradedTime(date);
		return date ? format(new Date(formattedTradedTime), 'dd MMM yyyy, h:mm a') : '';
	}
};
